import React, { useState, useEffect } from "react";
import Login from "../Logins/Login";
import Registration from "../Logins/Registration";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  setModelShow,
  authActions,
} from "../../redux/athentication/Athentication";
import { useDispatch, useSelector } from "react-redux";
import { MdCall, MdPhoneCallback } from "react-icons/md";
import {
  FiChevronDown,
  FiPlus,
  FiUser,
  FiHeadphones,
  FiX,
  FiGrid,
  FiPackage,
  FiHome,
  FiCheckCircle,
  FiList,
  FiPhoneCall,
  FiLogOut,
  FiSearch,
  FiChevronRight,
  FiHeart,
} from "react-icons/fi";
import {
  pageStatusChange,
  setuserIdRemove,
} from "../../redux/property/PropertySlice";
import { IoSearchSharp } from "react-icons/io5";
import { Baseurl } from "../../config/BaseUrl";
import axios from "axios";
import { setsearchObjects } from "../../redux/search/SearchSlice";
import { getShortlistCount } from "../../utils/shortlistUtils";
import "./HeaderNew.css";

const Header = () => {
  const { modelShow, loginData, isAuth } = useSelector(
    (store) => store.Athentication
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [menubar, setMenubar] = useState(false);
  const [propertyId, setPropertyId] = useState("");
  const [searchError, setSearchError] = useState("");
  const [shortlistCount, setShortlistCount] = useState(getShortlistCount());

  useEffect(() => {
    const updateCount = () => {
      setShortlistCount(getShortlistCount());
    };
    updateCount();
    window.addEventListener("mgh_shortlist_updated", updateCount);
    window.addEventListener("storage", updateCount);
    return () => {
      window.removeEventListener("mgh_shortlist_updated", updateCount);
      window.removeEventListener("storage", updateCount);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setMenubar(false);
      }
    };
    if (menubar) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyDown);
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [menubar]);

  const InputClick = () => {
    if (propertyId === "") {
      setSearchError("Please enter the property ID.");
    } else {
      setSearchError("");
    }
  };

  const handleChange = (e) => {
    setPropertyId(e.target.value);
    if (searchError !== "") {
      setSearchError("");
    }
  };

  const SearchBtn = async () => {
    if (propertyId !== "") {
      const paramstext = propertyId.toUpperCase();
      const url = `${Baseurl}/api/v1/property/propertybyprojectid/${paramstext}`;
      try {
        const fetchProperty = await axios.get(url);
        if (fetchProperty.data.success === true) {
          const searchresult = fetchProperty.data.property;
          const apartName =
            searchresult.apartment &&
              typeof searchresult.apartment === "string" &&
              searchresult.apartment.trim() !== ""
              ? searchresult.apartment.trim()
              : searchresult.propertyID || "commercial";
          navigate(`/property-info/${apartName}/${searchresult.propertyID}`);
          setMenubar(false);
          setPropertyId("");
        }
      } catch (error) { }
    }
  };

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      SearchBtn();
    }
  };

  const logoutClick = () => {
    dispatch(authActions.signout());
    dispatch(setuserIdRemove());
    navigate("/");
    window.location.reload(false);
  };

  const buyHomeClick = (supercategory, cate, mysubcat) => {
    let findsearch = "Hyderabad";
    let finalLocalityArray = ["Hyderabad"];
    let checkmysubcat = mysubcat
      ? mysubcat.replaceAll(",", "-").replaceAll("/", "-").replaceAll(" ", "-")
      : "All";

    const searchFormdta = {
      selectedSubcat: [mysubcat],
      selectedCity: finalLocalityArray,
      selectedBedrooms: [],
      selectedConustruction: [],
      selectedPostedBy: [],
      propertyPrice: [],
      selectedSharing: [],
      selectedAvailables: [],
      selectedFurnished: [],
      selectedSeatType: [],
      selectedPlan: [],
      selectedNoSeat: [],
      selectLand: [],
      selectedArea: [],
      selectProjectStatus: [],
    };
    dispatch(setsearchObjects(searchFormdta));
    navigate(
      `/property-search/${supercategory}/${cate}/${checkmysubcat}/${findsearch}`
    );
  };

  const residentialPgClick = (supercategory, cate, mysubcat) => {
    buyHomeClick(supercategory, cate, mysubcat);
  };

  const residentialPlotClick = (supercategory, cate, mysubcat) => {
    buyHomeClick(supercategory, cate, mysubcat);
  };

  const commercialClick = (supercategory, cate, mysubcat) => {
    buyHomeClick(supercategory, cate, mysubcat);
  };

  const residentialPopularAreaClick = (supercategory, cate, mysubcat, area) => {
    let findsearch = "Hyderabad";
    let finalLocalityArray = [area];
    let checkmysubcat = mysubcat
      ? mysubcat.replaceAll(",", "-").replaceAll("/", "-").replaceAll(" ", "-")
      : "All";

    const searchFormdta = {
      selectedSubcat: [],
      selectedCity: finalLocalityArray,
      selectedBedrooms: [],
      selectedConustruction: [],
      selectedPostedBy: [],
      propertyPrice: [],
      selectedSharing: [],
      selectedAvailables: [],
      selectedFurnished: [],
      selectedSeatType: [],
      selectedPlan: [],
      selectedNoSeat: [],
      selectLand: [],
      selectedArea: [],
      selectProjectStatus: [],
    };
    dispatch(setsearchObjects(searchFormdta));
    navigate(
      `/property-search/${supercategory}/${cate}/${checkmysubcat}/${findsearch}`
    );
  };

  const location = useLocation();
  if (location.pathname.startsWith("/property-search")) {
    return null;
  }

  return (
    <>
      <header className="mgh-header-container">
        {/* Left: Logo */}
        <Link to="/" className="mgh-header-logo">
          <img
            src="/assets/images/logo4.png"
            alt="EwRealty"
            className="mgh-logo-img"
          />
        </Link>

        {/* Right Group: Navigation, Support, Profile, Button, Hamburger */}
        <div className="mgh-header-right">
          {/* Desktop Mega Nav Links */}
          <div className="mgh-nav-desktop-links">
            {/* For Buyers */}
            <div className="mgh-nav-item">
              <button type="button" className="mgh-nav-link">
                <span>For Buyers</span>
                <FiChevronDown />
              </button>
              <div className="mgh-dropdown-menu">
                <div className="mgh-dropdown-columns">
                  {/* Col 1 */}
                  <div className="mgh-dropdown-col">
                    <span className="mgh-sub-header">BUY A HOME</span>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Sell", "Flat/apartment")}
                    >
                      Flats in Hyderabad
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Sell", "Villa")}
                    >
                      Villas in Hyderabad
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Sell", "Independent House")}
                    >
                      Independent House
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Sell", "Independent/Builder Floor")}
                    >
                      Builder Floors
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Sell", "Plot")}
                    >
                      Plots in Hyderabad
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Sell", "Farmhouse")}
                    >
                      Farm Houses
                    </div>
                  </div>

                  {/* Col 2 */}
                  <div className="mgh-dropdown-col">
                    <span className="mgh-sub-header">COMMERCIAL & PLOTS</span>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => residentialPlotClick("Residential", "Sell", "Plot")}
                    >
                      Gated Community Plots
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => commercialClick("Commercial", "Sell", "Office")}
                    >
                      Ready Office Spaces
                    </div >
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => commercialClick("Commercial", "Sell", "Hospitality")}
                    >
                      Commercial Hospitality
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => commercialClick("Commercial", "Sell", "Storage")}
                    >
                      Storage & Warehousing
                    </div>
                  </div>

                  {/* Col 3 */}
                  <div className="mgh-dropdown-col">
                    <span className="mgh-sub-header">POPULAR AREAS</span>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => residentialPopularAreaClick("Residential", "Sell", "All", "Kondapur")}
                    >
                      Property in Kondapur
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => residentialPopularAreaClick("Residential", "Sell", "All", "Gachibowli")}
                    >
                      Property in Gachibowli
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => residentialPopularAreaClick("Residential", "Sell", "All", "Manikonda")}
                    >
                      Property in Manikonda
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => residentialPopularAreaClick("Residential", "Sell", "All", "Miyapur")}
                    >
                      Property in Miyapur
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* For Tenants */}
            <div className="mgh-nav-item">
              <button type="button" className="mgh-nav-link">
                <span>For Tenants</span>
                <FiChevronDown />
              </button>
              <div className="mgh-dropdown-menu">
                <div className="mgh-dropdown-columns">
                  <div className="mgh-dropdown-col">
                    <span className="mgh-sub-header">RENT A HOME</span>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Rent", "Flat/apartment")}
                    >
                      Flats for Rent
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Rent", "Villa")}
                    >
                      Villas for Rent
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Rent", "Independent/Builder Floor")}
                    >
                      Builder Floors for Rent
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => buyHomeClick("Residential", "Rent", "1 RK/Studio Apartment")}
                    >
                      Studio Apartments
                    </div>
                  </div>

                  <div className="mgh-dropdown-col">
                    <span className="mgh-sub-header">PG & COMMERCIAL</span>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => residentialPgClick("Residential", "Pg", "All")}
                    >
                      PG for Girls
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => residentialPgClick("Residential", "Pg", "All")}
                    >
                      PG for Boys
                    </div>
                    <div
                      className="mgh-dropdown-link"
                      onClick={() => commercialClick("Commercial", "Rent", "Office")}
                    >
                      Commercial Office Space
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* For Owners */}
            <div className="mgh-nav-item">
              <button type="button" className="mgh-nav-link">
                <span>For Owners</span>
                <FiChevronDown />
              </button>
              <div className="mgh-dropdown-menu">
                <div className="mgh-dropdown-col" style={{ minWidth: "220px" }}>
                  <span className="mgh-sub-header">OWNER SERVICES</span>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => {
                      if (isAuth) {
                        navigate("/postPropertyHome");
                      } else {
                        navigate("/login");
                      }
                    }}
                  >
                    Post Property for Free
                  </div>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => {
                      if (isAuth) {
                        navigate("/postPropertyHome");
                      } else {
                        navigate("/login");
                      }
                    }}
                  >
                    Two Post Free
                  </div>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => {
                      if (isAuth) {
                        navigate("/dashboard");
                        dispatch(pageStatusChange(21));
                      } else {
                        navigate("/login");
                      }
                    }}
                  >
                    View Responses
                  </div>
                </div>
              </div>
            </div>

            {/* For Dealers / Builders */}
            <div className="mgh-nav-item">
              <button type="button" className="mgh-nav-link">
                <span>For Dealers / Builders</span>
                <FiChevronDown />
              </button>
              <div className="mgh-dropdown-menu">
                <div className="mgh-dropdown-col" style={{ minWidth: "240px" }}>
                  <span className="mgh-sub-header">DEALER OFFERINGS</span>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => {
                      if (isAuth) {
                        navigate("/postPropertyHome");
                      } else {
                        navigate("/login");
                      }
                    }}
                  >
                    Post Property
                  </div>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => {
                      if (isAuth) {
                        navigate("/dashboard");
                        dispatch(pageStatusChange(9));
                      } else {
                        navigate("/login");
                      }
                    }}
                  >
                    Dealer Services
                  </div>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => {
                      if (isAuth) {
                        navigate("/dashboard");
                        dispatch(pageStatusChange(21));
                      } else {
                        navigate("/login");
                      }
                    }}
                  >
                    View Responses
                  </div>
                  <div
                    className="mgh-dropdown-link"
                    onClick={() => navigate("/contactus")}
                  >
                    Customer Support & FAQs
                  </div>
                </div>
              </div>
            </div>

            {/* Headset / Support */}
            <div className="mgh-nav-item">
              <button type="button" className="mgh-headset-btn" title="Customer Support">
                <FiHeadphones />
              </button>
              <div className="mgh-support-card">
                <div className="mgh-support-item">
                  <div className="mgh-support-icon">
                    <MdCall />
                  </div>
                  <div className="mgh-support-info">
                    <h5>Toll Free | 9 AM - 8 PM IST</h5>
                    <p>+91 9063483711</p>
                  </div>
                </div>
                <div
                  className="mgh-support-item"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/contactus")}
                >
                  <div
                    className="mgh-support-icon"
                    style={{ background: "#ecfdf5", color: "#059669" }}
                  >
                    <MdPhoneCallback />
                  </div>
                  <div className="mgh-support-info">
                    <h5>Customer Helpdesk</h5>
                    <p>Request a Call Back</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* User Profile / Sign In */}
          {isAuth ? (
            <div className="mgh-nav-item">
              <button type="button" className="mgh-user-btn">
                <span>{loginData?.name || "Ganesh"}</span>
                <FiChevronDown />
              </button>
              <div className="mgh-profile-dropdown">
                <div
                  className="mgh-dropdown-link"
                  style={{ color: "#d97706", fontWeight: 700 }}
                  onClick={() => navigate("/dashboard")}
                >
                  My MGH Dashboard
                </div>
                <div
                  className="mgh-dropdown-link"
                  onClick={() => {
                    navigate("/dashboard");
                    dispatch(pageStatusChange(4));
                  }}
                >
                  Manage Listings
                </div>
                <div
                  className="mgh-dropdown-link"
                  onClick={() => {
                    navigate("/dashboard");
                    dispatch(pageStatusChange(21));
                  }}
                >
                  View All Responses
                </div>
                <div
                  className="mgh-dropdown-link"
                  onClick={() => navigate("/shortlisted")}
                >
                  Shortlisted Properties
                </div>
                <div
                  className="mgh-dropdown-link"
                  style={{ color: "#dc2626", borderTop: "1px solid #f1f5f9", marginTop: "4px" }}
                  onClick={logoutClick}
                >
                  Logout
                </div>
              </div>
            </div>
          ) : (
            <button
              type="button"
              className="mgh-user-btn"
              onClick={() => navigate("/login")}
            >
              <FiUser style={{ fontSize: "16px", marginRight: "2px" }} />
              <span>Sign In</span>
            </button>
          )}

          {/* Shortlisted Quick Button */}
          <Link
            to="/shortlisted"
            className="mgh-header-fav-link"
            title="Shortlisted Properties"
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: "#fff1f2",
              color: "#e11d48",
              border: "1px solid #ffe4e6",
              textDecoration: "none",
              margin: "0 4px",
            }}
          >
            <FiHeart size={17} />
            {shortlistCount > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "-4px",
                  right: "-4px",
                  background: "#e11d48",
                  color: "#ffffff",
                  fontSize: "10px",
                  fontWeight: 700,
                  minWidth: "16px",
                  height: "16px",
                  lineHeight: "16px",
                  borderRadius: "8px",
                  textAlign: "center",
                  padding: "0 4px",
                  boxShadow: "0 2px 4px rgba(225, 29, 72, 0.4)",
                  border: "1.5px solid #ffffff",
                }}
              >
                {shortlistCount}
              </span>
            )}
          </Link>

          {/* Post Property Button (Brand Orange Pill with Free Badge) */}
          {isAuth ? (
            <Link to="/postPropertyHome" className="mgh-post-property-btn">
              <div className="mgh-plus-circle">
                <FiPlus />
              </div>
              <span className="mgh-post-btn-text">Post Property</span>
              <span className="mgh-post-btn-text-short">Post</span>
              <span className="mgh-free-pill">FREE</span>
            </Link>
          ) : (
            <button
              type="button"
              className="mgh-post-property-btn"
              onClick={() => navigate("/login")}
            >
              <div className="mgh-plus-circle">
                <FiPlus />
              </div>
              <span className="mgh-post-btn-text">Post Property</span>
              <span className="mgh-post-btn-text-short">Post</span>
              <span className="mgh-free-pill">FREE</span>
            </button>
          )}

          {/* 3 Black Horizontal Bars (Menu Toggle) */}
          <button
            type="button"
            className="mgh-menu-toggle-btn"
            onClick={() => setMenubar(!menubar)}
            title="Menu"
          >
            <span className="mgh-hamburger-bar" />
            <span className="mgh-hamburger-bar" />
            <span className="mgh-hamburger-bar" />
          </button>
        </div>
      </header>

      {/* Smooth Offcanvas Drawer Overlay */}
      <div
        className={`mgh-drawer-overlay ${menubar ? "active" : ""}`}
        onClick={() => setMenubar(false)}
      />

      {/* Smooth Sliding Drawer */}
      <div className={`mgh-drawer ${menubar ? "active" : ""}`}>
        {/* Drawer Header */}
        <div className="mgh-drawer-header">
          <div className="mgh-drawer-brand">
            <img
              src="/assets/images/logo4.png"
              alt="EwRealty"
              className="mgh-drawer-logo"
            />
          </div>
          <button
            type="button"
            className="mgh-drawer-close-btn"
            onClick={() => setMenubar(false)}
            aria-label="Close Menu"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Drawer Body (Scrollable) */}
        <div className="mgh-drawer-body">
          {/* User Profile Card */}
          <div className="mgh-drawer-user-card">
            <div className="mgh-drawer-avatar">
              <FiUser size={22} />
            </div>
            <div
              className="mgh-drawer-user-info"
              style={{
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "center",
              }}
            >
              <h4 style={{ textAlign: "left", width: "100%", margin: "0 0 2px 0" }}>
                {loginData?.name || "Welcome Guest"}
              </h4>
              <p style={{ textAlign: "left", width: "100%", margin: 0 }}>
                {isAuth
                  ? loginData?.email || loginData?.mobile || "Account active"
                  : "Sign in to manage your properties"}
              </p>
            </div>
            {!isAuth && (
              <button
                type="button"
                className="mgh-drawer-login-btn"
                onClick={() => {
                  setMenubar(false);
                  navigate("/login");
                }}
              >
                Sign In
              </button>
            )}
          </div>

          {/* Highlighted Post Property Card in Mobile Drawer */}
          <div className="mgh-drawer-post-card">
            <div className="mgh-drawer-post-badge">
              <span>EXCLUSIVE &bull; 100% FREE</span>
            </div>
            <h4>Sell or Rent Your Property Fast</h4>
            <p>Connect directly with genuine buyers with zero brokerage</p>
            <button
              type="button"
              className="mgh-drawer-post-cta"
              onClick={() => {
                setMenubar(false);
                if (isAuth) {
                  navigate("/postPropertyHome");
                } else {
                  navigate("/login");
                }
              }}
            >
              <div className="mgh-plus-circle">
                <FiPlus />
              </div>
              <span>Post Property Now</span>
              <span className="mgh-free-pill">FREE</span>
            </button>
          </div>

          {/* Main Navigation / Shortcuts */}
          <div className="mgh-drawer-section">
            <span className="mgh-drawer-section-title">Account & Dashboard</span>
            <ul className="mgh-drawer-nav-list">
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item mgh-drawer-nav-highlight"
                  onClick={() => {
                    setMenubar(false);
                    if (isAuth) {
                      navigate("/postPropertyHome");
                    } else {
                      navigate("/login");
                    }
                  }}
                >
                  <div className="mgh-drawer-icon-wrap" style={{ background: "#fff7ed", color: "#ea580c" }}>
                    <FiPlus size={18} />
                  </div>
                  <span style={{ fontWeight: 700, color: "#ea580c" }}>Post Property</span>
                  <span className="mgh-free-pill" style={{ marginLeft: "auto", marginRight: "6px" }}>FREE</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/dashboard");
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiGrid size={18} />
                  </div>
                  <span>Dashboard Overview</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/dashboard");
                    dispatch(pageStatusChange(9));
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiPackage size={18} />
                  </div>
                  <span>Packages & Plans</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/dashboard");
                    dispatch(pageStatusChange(4));
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiHome size={18} />
                  </div>
                  <span>Your Properties</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/dashboard");
                    dispatch(pageStatusChange(21));
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiCheckCircle size={18} />
                  </div>
                  <span>All Inquiries & Responses</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/shortlisted");
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap" style={{ color: "#e11d48", background: "#fff1f2" }}>
                    <FiHeart size={18} />
                  </div>
                  <span>Shortlisted Properties {shortlistCount > 0 && `(${shortlistCount})`}</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
            </ul>
          </div>

          {/* Mobile Categories (Visible on smaller screens) */}
          <div className="mgh-drawer-section mgh-drawer-mobile-only">
            <span className="mgh-drawer-section-title">Explore Real Estate</span>
            <ul className="mgh-drawer-nav-list">
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    buyHomeClick("Residential", "Sell", "Apartment");
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiHome size={18} />
                  </div>
                  <span>For Buyers</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
              <li>
                <button
                  type="button"
                  className="mgh-drawer-nav-item"
                  onClick={() => {
                    navigate("/all-properties");
                    setMenubar(false);
                  }}
                >
                  <div className="mgh-drawer-icon-wrap">
                    <FiList size={18} />
                  </div>
                  <span>For Tenants</span>
                  <FiChevronRight className="mgh-drawer-arrow" size={16} />
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Drawer Footer */}
        <div className="mgh-drawer-footer">
          <a
            href="tel:+919063483711"
            className="mgh-drawer-support-box"
          >
            <div className="mgh-drawer-support-icon">
              <FiPhoneCall size={18} />
            </div>
            <div className="mgh-drawer-support-text">
              <span>Toll Free Helpline</span>
              <strong>+91 90634 83711</strong>
            </div>
          </a>

          {isAuth && (
            <button
              type="button"
              className="mgh-drawer-logout-btn"
              onClick={logoutClick}
            >
              <FiLogOut size={16} />
              <span>Sign Out</span>
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
